<template>
    <Teleport to="body">
        <Transition name="fade">
            <div 
                v-if="abrirModal" 
                class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50"
                @click.self="closeModal">
                <Transition name="scale">
                    <div 
                        v-if="abrirModal"
                        class="relative bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full p-6 border border-gray-200 dark:border-slate-700"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="modal-title">
                        
                        <!-- Icon -->
                        <div class="flex justify-center mb-4">
                            <div class="relative w-16 h-16">
                                <div class="absolute inset-0 bg-green-100 dark:bg-green-900/30 rounded-full"></div>
                                <div class="absolute inset-2 bg-green-200 dark:bg-green-800/40 rounded-full"></div>
                                <div class="absolute inset-0 flex items-center justify-center">
                                    <svg class="w-10 h-10 text-green-600 dark:text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <!-- Title -->
                        <h4 
                            id="modal-title"
                            class="text-xl font-semibold text-center mb-3 text-gray-900 dark:text-gray-100">
                            Análise inicial concluída!
                        </h4>

                        <!-- Body -->
                        <div class="text-center text-gray-600 dark:text-gray-400 mb-6 space-y-3">
                            <p>
                                Para finalizar o cadastro, acesse o App da Genial Investimentos:
                            </p>
                            <div class="flex items-center justify-center gap-2 text-sm">
                                <a 
                                    target="_blank" 
                                    href="https://app.genialinvestimentos.com.br/auth/login"
                                    class="font-medium text-blue-600 dark:text-blue-400 hover:underline">
                                    Acessar App
                                </a>
                                <span>ou</span>
                                <a 
                                    target="_blank" 
                                    href="https://lp.genialinvestimentos.com.br/baixeoapp/"
                                    class="font-medium text-blue-600 dark:text-blue-400 hover:underline">
                                    baixar app
                                </a>
                            </div>
                        </div>

                        <!-- Footer -->
                        <button
                            @click="closeModal"
                            class="w-full py-2.5 px-4 rounded-lg text-white transition-colors font-medium bg-green-600 hover:bg-green-700 dark:bg-green-600 dark:hover:bg-green-700">
                            OK
                        </button>
                    </div>
                </Transition>
            </div>
        </Transition>
    </Teleport>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            abrirModal: 'GET_MODAL_AVISO_APROVACAO_PERSONALIZADA'
        })
    },
    methods: {
        closeModal() {
            this.$store.commit('SET_MODAL_AVISO_APROVACAO_PERSONALIZADA', false);
        }
    }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.2s ease;
}

.scale-enter-from,
.scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>